// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { Button, Column, Modal, ModalContent, ModalFooter, spacing } from '@alto/pocky';
import {
  type RejectCategoryType,
  RejectCategoryTypeMap,
} from '@alto/scriptdash/alto/billing/types/v1/reject_category_type';
import React from 'react';
import {
  renderAltOutOfNetworkMessage,
  renderAltOutOfNetworkProductMessage,
  renderHeader,
  renderNotCoveredMessage,
  renderPriorAuthRequiredMessage,
} from './NotCoveredByInsuranceModalMessages';
import { ButtonWrapper } from '~web/components/ButtonWrapper';

type Props = {
  readonly onClose: () => void;
  readonly isFertility: boolean;
  readonly insuranceName: string;
  readonly reject_category: RejectCategoryType;
};

const NotCoveredByInsuranceModal = ({ onClose, isFertility, insuranceName, reject_category }: Props) => {
  const renderMessage = () => {
    switch (reject_category) {
      case RejectCategoryTypeMap.PRODUCT_NOT_COVERED_OTC:
      case RejectCategoryTypeMap.PRODUCT_NOT_COVERED_BELOW_THRESHOLD:
      case RejectCategoryTypeMap.PRODUCT_NOT_COVERED:
        return renderNotCoveredMessage(insuranceName, isFertility);

      case RejectCategoryTypeMap.ALTO_OUT_OF_NETWORK:
        return renderAltOutOfNetworkMessage(insuranceName);

      case RejectCategoryTypeMap.ALTO_OUT_OF_NETWORK_PRODUCT:
        return renderAltOutOfNetworkProductMessage(insuranceName);

      case RejectCategoryTypeMap.PA_REQUIRED_CLINIC_OPT_OUT:
      case RejectCategoryTypeMap.PA_REQUIRED_VERBAL:
        return renderPriorAuthRequiredMessage(insuranceName);

      default:
        return null;
    }
  };

  return (
    <Modal
      dismissOnOutsideClick
      showDismiss
      onClose={onClose}
    >
      <ModalContent>
        <Column spacing={spacing.xsSpacing}>
          {renderHeader()}
          {renderMessage()}
        </Column>
      </ModalContent>
      <ModalFooter>
        <ButtonWrapper horizontallyAlignContent>
          <Button onClick={onClose}>Got It</Button>
        </ButtonWrapper>
      </ModalFooter>
    </Modal>
  );
};

export default NotCoveredByInsuranceModal;
